import { Box, makeStyles, Typography } from '@material-ui/core';
import { FC } from 'react';
import { COLUMN_WIDTHS, COLUMN_MIN_WIDTHS } from '../column-widths';

const useStyles = makeStyles(() => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '12px',
    background: '#EEF0F2',
    borderRadius: 8,
    width: '100%'
  },
  productInfoColumn: {
    minWidth: COLUMN_MIN_WIDTHS.productInfo,
    flex: 1
  },
  qtyColumn: {
    width: COLUMN_WIDTHS.qty,
    minWidth: COLUMN_MIN_WIDTHS.qty,
    flexShrink: 1,
    textAlign: 'center'
  },
  unitPriceColumn: {
    width: COLUMN_WIDTHS.unitPrice,
    minWidth: COLUMN_MIN_WIDTHS.unitPrice,
    flexShrink: 1,
    textAlign: 'center'
  },
  gpColumn: {
    width: COLUMN_WIDTHS.gp,
    minWidth: COLUMN_MIN_WIDTHS.gp,
    flexShrink: 1,
    textAlign: 'center'
  },
  totalPriceColumn: {
    width: COLUMN_WIDTHS.totalPrice,
    minWidth: COLUMN_MIN_WIDTHS.totalPrice,
    flexShrink: 1,
    textAlign: 'center'
  },
  actionColumn: {
    width: COLUMN_WIDTHS.action,
    flexShrink: 0
  },
  headerText: {
    color: '#5D7083',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: 0
  }
}));

export const ProductsTableHeader: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.productInfoColumn}>
        <Typography className={classes.headerText}>
          Product Name & SKU
        </Typography>
      </Box>
      <Box className={classes.qtyColumn}>
        <Typography className={classes.headerText}>Quantity</Typography>
      </Box>
      <Box className={classes.unitPriceColumn}>
        <Typography className={classes.headerText}>Unit Price</Typography>
      </Box>
      <Box className={classes.gpColumn}>
        <Typography className={classes.headerText}>GP</Typography>
      </Box>
      <Box className={classes.totalPriceColumn}>
        <Typography className={classes.headerText}>Total Price</Typography>
      </Box>
      <Box className={classes.actionColumn}>
        <Typography
          className={classes.headerText}
          style={{
            textAlign: 'right',
            marginRight: 8
          }}>
          Action
        </Typography>
      </Box>
    </Box>
  );
};
